import HouseIcon from "@redotech/redo-icons/home-02.svg";
import { BooleanFilterOperator } from "@redotech/redo-model/views/advanced-filters/boolean-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import { BooleanTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export const AddressVerifiedFilter: BooleanTableFilter = {
  type: AdvancedFilterType.BOOLEAN,
  data: {
    name: "addressVerified",
    type: AdvancedFilterType.BOOLEAN,
    value: null,
    operator: BooleanFilterOperator.IS,
  },
  Icon: HouseIcon,
  displayName: "Address verified",
  label: "Address",
  boolDisplay: { falseDisplay: "unverified", trueDisplay: "verified" },
};
